var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"padding-bottom":"32px"}},[_c('Title',{attrs:{"text":"数据概览"}})],1),_c('SectionCards'),_c('div',{staticStyle:{"padding":"24px 0 32px 0"}},[_c('Title',{attrs:{"text":"我的业绩"}})],1),_c('SectionAchieve')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }